import {Checkbox as TailwindCheckbox} from "@material-tailwind/react";
import {Check} from "@mui/icons-material";
import React from "react";

interface Props {
    classNameContent?: string;
    label?: string;
    disabled?: boolean;
    value: boolean;
    setValue?: React.Dispatch<React.SetStateAction<boolean>>;
    event?: any;
    textSize?: string;
}
export const CustomCheckbox = ({classNameContent, label, disabled, value, setValue, event, textSize}: Props) => {

    const onChange = () => {
      if (event) {
          event()
      } else if (setValue) {
          setValue((prevValue) => !prevValue)
      }
    }

    return(
        <div className={`${classNameContent} flex items-center ${disabled ? 'pointer-events-none' : ''}`}>
            <TailwindCheckbox
                crossOrigin=''
                checked={value}
                onChange={onChange}
                className={`rounded-[4px] border-[2px] ${disabled ? 'pointer-events-none border-textCheckboxDisabled' : 'border-textCheckbox'}`}
                icon={
                    <div className={`rounded-[3px] h-[20px] w-[20px] ${disabled ? 'bg-textCheckboxDisabled' : value ? 'bg-primary' : 'bg-white'} p-0`}>
                        {value && <Check className={'max-w-[20px] mt-[-2px]'}/>}
                    </div>
                }
            />
            {label && <span className={`text-[${textSize ? textSize : '16px'}] text-textCheckbox`}>{label}</span>}
        </div>
    )
}
